
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/egypt/purchase-pass",
      function () {
        return require("private-next-pages/egypt/purchase-pass.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/egypt/purchase-pass"])
      });
    }
  